import { Layer } from "../types/layers";

interface UseLayer {
  layerId: string;
}

const useLayer = ({ layerId }: UseLayer) => {
  const findLayer = (layers: Layer[], id: string): null | Layer => {
    for (const layer of layers) {
      if (layer.id === id) {
        return layer;
      }

      if (layer.layers) {
        const found = findLayer(layer.layers, id);
        if (found) {
          return found;
        }
      }
    }

    return null;
  };

  let foundLayer = null;

  return foundLayer;
};

export default useLayer;
